import api from "../api";

const toList = (data) => (Array.isArray(data) ? data : (data?.results ?? []));

export const templatesService = {
  fetchTemplateGroups: async () => {
    const res = await api.get("/api/templates/template-groups/summary/");
    return toList(res.data);
  },

  fetchTemplateGroupById: async (id) => {
    const res = await api.get(`/api/templates/template-groups/${id}/`);
    return res.data;
  },

  createTemplateGroup: async (data) => {
    const res = await api.post("/api/templates/template-groups/", data);
    return res.data;
  },

  updateTemplateGroup: async (id, data) => {
    const res = await api.patch(`/api/templates/template-groups/${id}/`, data);
    return res.data;
  },

  deleteTemplateGroup: async (id) => {
    const res = await api.delete(`/api/templates/template-groups/${id}/`);
    return res.data;
  },

  fetchTemplateFiles: async (templateGroupId) => {
    const res = await api.get(
      `/api/templates/template-files/?template_group_id=${templateGroupId}`,
    );
    return res.data;
  },

  updateTemplateFiles: async (templateGroupId, data) => {
    const res = await api.patch(
      `/api/templates/template-files/${templateGroupId}/`,
      data,
    );
    return res.data;
  },

  createTemplateFile: async (data) => {
    const res = await api.post("/api/templates/template-files/", data);

    return res.data;
  },

  deleteTemplateFile: async (templateFileId) => {
    const res = await api.delete(
      `/api/templates/template-files/${templateFileId}/`,
    );
    return res.data;
  },

  fetchTemplateFilesAttachments: async (params = {}) => {
    const res = await api.get(`/api/templates/template-file-attachments/`, {
      params,
    });
    return res.data;
  },

  fetchAttachmentsForTemplateFile: async (templateFileId) => {
    const res = await api.get(
      `/api/templates/template-file-attachments/?template_file_id=${templateFileId}`,
    );
    return res.data;
  },

  createTemplateFileAttachment: async (formData) => {
    const res = await api.post(
      "/api/templates/template-file-attachments/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res.data;
  },

  deleteTemplateFileAttachment: async (attachmentId) => {
    const response = await api.delete(
      `/api/templates/template-file-attachments/${attachmentId}/`,
    );

    return response.data;
  },

  linkTemplateFileAttachment: async (attachmentId, templateFileId) => {
    const res = await api.post(
      `/api/templates/template-file-attachments/${attachmentId}/link/`,
      { template_file_id: templateFileId },
    );

    return res.data;
  },

  unlinkTemplateFileAttachment: async (attachmentId, templateFileId) => {
    const res = await api.post(
      `/api/templates/template-file-attachments/${attachmentId}/unlink/`,
      { template_file_id: templateFileId },
    );

    return res.data;
  },
};
